import { memo, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router'

import { useSelector } from '@tabeeb/store'
import { PageHeaderContext } from '@collaborate-health/uikit'
import { PageHeaderContextValue } from '@collaborate-health/uikit/components/PageHeader/PageHeaderContext'
import { getIsSideNavbarEnabled } from '@tabeeb/modules/appConfigState/selectors'

const PageLayoutContextProvider: React.FC = ({ children }) => {
  const history = useHistory()

  const onNavigateBack = useCallback(() => {
    if (history.length <= 1) {
      history.replace('/')

      return
    }

    history.goBack()
  }, [history])

  const isSideNavbarEnabled = useSelector(getIsSideNavbarEnabled)

  const value = useMemo<PageHeaderContextValue>(
    () => ({
      navbar: isSideNavbarEnabled,
      onNavigateBack,
    }),
    [isSideNavbarEnabled, onNavigateBack]
  )

  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>
}

export default memo(PageLayoutContextProvider)

